import req from '../req'
// 业绩配比

// 获取默认规则
export function getDefaultSetting (params) {
  return req.get('/statistic/performance/default-setting-get', params)
}

// 保存默认规则
export function saveDefaultSettingList (params) {
  return req.post('/statistic/performance/default-setting-save', params)
}

// 获取自定义规则列表
export function getOtherSettingList (params) {
  return req.get('/statistic/performance/otherrule-setting-lists', params)
}

// 获取自定义规则详情

export function getOtherSettingDetail (id, params) {
  return req.get('/statistic/performance/otherrule-setting-info/' + id, params)
}

// 保存其他自定义规则
export function saveOtherSetting (params) {
  return req.post('/statistic/performance/otherrule-setting-save', params)
}

// 删除自定义规则详情
export function deleteOtherSetting (id, params) {
  return req.post('/statistic/performance/otherrule-setting-del/' + id, params)
}
